import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

const STATUS_META = {
  healthy: { color: 'success', label: 'Healthy' },
  warning: { color: 'warning', label: 'Warning' },
  critical: { color: 'error', label: 'Critical' },
}

export default function ProductOperationalStatusTable({
  rows = [],
  onNavigateProduct,
}) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, overflow: 'hidden' }}>
      <Stack spacing={0}>
        <Stack sx={{ p: 2.5, pb: 1.5 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Estado operacional por producto
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Resumen rápido para identificar productos con cobertura incompleta de layouts.
          </Typography>
        </Stack>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Producto</TableCell>
                <TableCell>Cliente</TableCell>
                <TableCell align="center">Layouts detectados</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Acción recomendada</TableCell>
                <TableCell align="right">Navegación</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const meta = STATUS_META[row.status] || STATUS_META.warning
                return (
                  <TableRow hover key={row.productId}>
                    <TableCell>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        {row.productName}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.clientName}</TableCell>
                    <TableCell align="center">{row.layoutsCount}</TableCell>
                    <TableCell>
                      <Chip size="small" label={meta.label} color={meta.color} />
                    </TableCell>
                    <TableCell>{row.recommendedAction}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => onNavigateProduct?.(row.productId)}
                        disabled={!row.productId}
                      >
                        Abrir manager
                      </Button>
                    </TableCell>
                  </TableRow>
                )
              })}
              {rows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Typography variant="body2" color="text.secondary">
                      No hay productos disponibles en el contexto actual.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Paper>
  )
}

ProductOperationalStatusTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      productName: PropTypes.string,
      clientName: PropTypes.string,
      layoutsCount: PropTypes.number,
      status: PropTypes.string,
      recommendedAction: PropTypes.string,
    })
  ),
  onNavigateProduct: PropTypes.func,
}
